<template>
  <el-dialog
    class="btn-close"
    title="支付订单"
    :append-modelody="true"
    :modal-append-to-body="false"
    :visible.sync="dialogVisible"
    :width="dialogWidth"
    :before-close="handleClose"
  >
    <div class="dialog-box">
      <div class="palyContent" style="display: block">
        <div>
          <ul>
            <li>
              <span style="margin-right: 0px">购买会员：</span
              ><b
                ><span style="font-size: 18px"
                  ><b id="allPrice2">{{ item.title }}</b>
                </span>
              </b>
            </li>
            <li style="margin-bottom: 10px">
              <span style="margin-right: 0px">支付金额：</span
              ><b
                ><span style="color: #ff8a00; font-size: 18px"
                  >￥<b id="allPrice2">{{ item.price || 0 }}</b>
                </span>
              </b>
            </li>
            <li>
              <table
                class="viewTable"
                width="100%"
                border="0"
                cellspacing="1"
                cellpadding="0"
                style="text-align: center"
              >
                <tbody>
                  <tr style="background: #f5f5f5">
                    <td>开户名称</td>
                    <td>开户银行</td>
                    <td>汇款账号</td>
                  </tr>
                  <tr style="border-bottom: 1px solid #ccc">
                    <td>中智国际人才资源服务有限公司</td>
                    <td>中国银行北京建国门外支行</td>
                    <td
                      style="
                        font-size: 18px;
                        font-weight: bolder;
                        color: #ff8a00;
                        padding: 0 2px;
                      "
                    >
                      319456011701
                    </td>
                  </tr>
                </tbody>
              </table>
            </li>
          </ul>
          <div
            class="inputnew"
            style="
              padding: 14px 14px;
              box-sizing: border-box;
              font-size: 13px;
              color: #666;
              line-height: 20px;
              background: #f5f5f6;
              margin-top: 20px;
            "
          >
            <h3 style="margin-bottom: 10px">温馨提示：</h3>
            <p>
              1、通过网银转账汇款后，如果没有实时到账，可以把转账汇款截屏，或汇款凭证发邮件给我们，我们会提前为您开通服务。E-mail：zhengyanjiao@acmcoder.com
            </p>
            <p>
              2、如果网银汇款到账后，我们客服人员会自动为您开通相关的服务，如有疑问，请咨询我们的客服热线：010-85359782
            </p>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <a class="btn" @click="openHandler">提交订单</a>
    </div>
  </el-dialog>
</template>
<script>
import { REPORT_API } from "@/api.js";
export default {
  props: ['dialogVisible', 'item', 'dialogWidth'],
  data() {
    return {}
  },
  methods: {
    handleClose(done) {
      this.$emit('onCancel')
    },
    openHandler() {
      let post = {
        type: this.item.mode,
      }
      this.info = this.$cookies.get('hr_token')
      if (this.info) {
        this.$axios.defaults.headers.common['authorization'] = this.info.token
      }
      this.$axios
        .post(`${REPORT_API}/api/enterprise/buy`, post)
        .then((res) => {
          if (res.data.code == 0) {
            this.$message.success('成功提交订单')
            this.$emit('onCancel')
          } else {
            this.$message.error(res.data.message)
          }
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.dialog-box {
  padding: 0px 0px;
  font-weight: 300;
  text-align: left;
  .viewTable {
    background: #ccc;
    tr td {
      background: #fff;
    }
  }
  .palyContent {
    margin: 0 auto;
    background: #fff;
    padding: 0px 10px;
    font-size: 14px;
    display: none;
    ul li {
      min-height: 40px;
      line-height: 40px;
    }
    .inputnew {
      padding: 14px;
      box-sizing: border-box;
      font-size: 13px;
      color: #666;
      line-height: 20px;
      background: #f5f5f6;
      margin-top: 20px;
    }
  }
}
</style>
<style lang='scss'>
@media screen and (max-width: 600px) {
  .el-dialog {
    width: 98% !important;
    .el-dialog__body {
      padding: 10px;
    }
  }
}
@media screen and (min-width: 600px) and (max-width: 1024px) {
  .el-dialog {
    width: 98% !important;
    .el-dialog__body {
      padding: 10px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pay/remittance.vue